module.exports = __webpack_public_path__ + "img/primary_7x1.85b49b56.svg";